// import "../../styling/style.css";
import {
  Alert,
  Card,
  CardContent,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import ConfirmationDialog from "../../components/dialog/simple-alert";
import Feedback from "../../components/feedback/feedback";
import Loading from "../../components/loading/loading";
import { selectUserProfile } from "../../store/auth/selector";
import { homeStyle } from "../../styles/container/home";
import {
  CheckAccessUserQuestionaire,
  getMasterQuestionnaire,
  SubmitQuestionnaire,
} from "./api-endpoint/callApi";

function Questionnaire() {
  const { id } = useParams();
  const profile = useSelector(selectUserProfile);
  const Navigate = useNavigate();
  const [loadingActive, setLoadingActive] = useState(false);
  const [feedbackText, setFeedbackText] = useState("");
  const [feedbackType, setFeedbackType] = useState("");
  const [openFeedback, setOpenFeedback] = useState(false);
  const [dataQuestion, setDataQuestion] = useState([]);
  const [answers, setAnswers] = useState({});
  const [tranformObjAnswers, setTranformObjAnswers] = useState([]);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [errorList, setErrorList] = useState([]);
  const [errorAlert, setErrorAlert] = useState(false);
  const [accessPage, setAccessPage] = useState(true);
  const containerCard = document.querySelector("#card-container");

  const checkAccessQuestionnairePage = async () => {
    const allowAccess = await CheckAccessUserQuestionaire(
      profile.BinusianId,
      id
    );
    if (allowAccess.data === false) {
      setAccessPage(false);
      setTimeout(() => {
        Navigate("/");
      }, 7000);
    } else {
      await getMasterQuestionnaireData();
    }
  };

  const getMasterQuestionnaireData = async () => {
    try {
      const dataAPI = await getMasterQuestionnaire();
      const getQuestion: any = [];
      dataAPI.data.forEach((x: any) => {
        const objQuestion = {
          questionId: x.questionnaireId,
          question: x.question,
          options: ["Very Good", "Fair", "Good", "Poor"],
        };
        getQuestion.push(objQuestion);
      });
      setDataQuestion(getQuestion);
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  const handleRadioChange = (event) => {
    setAnswers({
      ...answers,
      [event.target.name]: event.target.value,
    });
  };

  const submitQuestionner = () => {
    setErrorAlert(false);
    const err: any = [];
    const tempErr: any = [];
    const transformedDataQuestionnaire: any = Object.entries(answers)
      .filter(
        ([QuestionnaireId, Answer]) =>
          Answer === "Very Good" ||
          Answer === "Poor" ||
          Answer === "Good" ||
          Answer === "Fair"
      )
      .map(([QuestionnaireId, Answer]) => ({ QuestionnaireId, Answer }));

    setTranformObjAnswers(transformedDataQuestionnaire);

    dataQuestion.forEach((obj: any, index: number) => {
      const findAnswer = transformedDataQuestionnaire.find(
        (dt: any) => dt.QuestionnaireId == obj.questionId
      );
      if (findAnswer === undefined) {
        err.push(`Question Number ${index + 1}`);
      }
    });

    if (err.length > 0) {
      setErrorAlert(true);
      for (const error of err) {
        tempErr.push(<li>{error}</li>);
      }
      setErrorList(tempErr);
      if (containerCard) {
        containerCard.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      setOpenConfirmation(true);
    }
  };

  const handleSubmit = async () => {
    setOpenConfirmation(false);

    const trQuestionnaire = JSON.stringify(tranformObjAnswers);
    setLoadingActive(true);
    const submit = await SubmitQuestionnaire(
      profile.BinusianId,
      id,
      trQuestionnaire
    );
    setLoadingActive(false);
    if (submit.resultCode === 200) {
      setFeedbackText("Your data has been successfully saved!");
      setFeedbackType("success");
      setOpenFeedback(true);
    } else {
      setFeedbackText("Failed to save data");
      setFeedbackType("failed");
      setOpenFeedback(true);
    }
    setTimeout(() => {
      Navigate("/");
    }, 3000);
  };

  const handleReset = () => {
    setAnswers({});
    setErrorAlert(false);
    if (containerCard) {
      containerCard.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const firstLoad = async () => {
      setLoadingActive(true);
      await checkAccessQuestionnairePage();
      setLoadingActive(false);
    };
    firstLoad();
  }, []);

  return (
    <Container maxWidth={false} disableGutters sx={homeStyle.containerStyling}>
      {!accessPage ? (
        <Alert variant="filled" severity="error">
          You have filled out this questionnaire or you are not entitled to fill
          out this questionnaire
        </Alert>
      ) : (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div id="card-container">
            <Card sx={{ width: 900, padding: "20px" }}>
              <CardContent>
                {errorAlert && (
                  <Alert variant="filled" severity="error">
                    Must be Filled :<ul>{errorList}</ul>
                  </Alert>
                )}
                <div style={{ textAlign: "center" }}>
                  <h1>Questionnaire</h1>
                  <p>
                    Please help us serve you better by taking two minutes to
                    tell us about your experience so far. <br /> We appreciate
                    your perspective
                  </p>
                </div>
                <h5>
                  <u>
                    Choose one of the answers that you suitable by click the box
                  </u>
                </h5>
                {dataQuestion.map((qs: any, i: number) => (
                  <>
                    <FormLabel component="legend">
                      {i + 1}. {qs.question}
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-label={qs.questionId}
                      name={qs.questionId}
                      value={answers[`${qs.questionId}`] || ""}
                      onChange={(e) => handleRadioChange(e)}
                    >
                      <Grid container justifyContent="space-between">
                        {qs.options.map((opt, index) => (
                          <Grid item xs={6} paddingLeft={3}>
                            <FormControlLabel
                              value={opt}
                              control={<Radio />}
                              label={opt}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </RadioGroup>
                  </>
                ))}
                <div style={{ textAlign: "center", marginTop: "2rem" }}>
                  <Button
                    variant="contained"
                    sx={{
                      m: 1,
                      width: "150px",
                      textTransform: "none",
                      fontWeight: "bold",
                    }}
                    type="submit"
                    onClick={submitQuestionner}
                  >
                    Submit
                  </Button>
                  <Button
                    variant="outlined"
                    sx={{
                      m: 1,
                      width: "150px",
                      textTransform: "none",
                      fontWeight: "bold",
                    }}
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      )}

      <Loading open={loadingActive} />

      <ConfirmationDialog
        open={openConfirmation}
        title="Confirmation"
        message="Are you sure you want to proceed ?"
        onConfirm={() => {
          handleSubmit();
        }}
        onCancel={() => {
          setOpenConfirmation(false);
        }}
      />

      <Feedback
        open={openFeedback}
        message={feedbackText}
        feedbackType={feedbackType}
        onClose={false}
      />
    </Container>

    // <Grid item lg={6} md={12} xs={12}>
    //                 <Typography variant="subtitle1" gutterBottom>
    //                   Komentar Legal / Comment from Legal
    //                 </Typography>
    //                 <TextFieldMultiDisabledComponent parentToChild="Komentarnya" />
    //                 <Typography variant="subtitle1" gutterBottom>
    //                   Bukti / Evidence
    //                 </Typography>
    //                 <DownloadFileComponent fileName="bukti.jpg" />
    //               </Grid>
    // <div>
    //   <h1>My Form</h1>
    //   <Formik
    //     initialValues={initialValues}
    //     onSubmit={onSubmitForm}
    //     validate={validation}
    //   >
    //     {(props) => (
    //       <form onSubmit={props.handleSubmit}>
    //         <TextFieldComponent propsData={props} name="name" />

    //         {/* <TextFieldComponent onChildDataChange={handleDataTextArea}/> */}
    //         {props.errors.name && (
    //           <div id="feedback">{props.errors.name}</div>
    //         )}

    //         <TextFieldComponent propsData={props} name="email" />
    //         {props.errors.email && (
    //           <div id="feedback">{props.errors.email}</div>
    //         )}

    //         <TextFieldDateComponent propsData={props} name="startDate" />
    //         {props.errors.startDate && (
    //           <div id="feedback">{props.errors.startDate}</div>
    //         )}

    //         <TextFieldDateComponent propsData={props} name="endDate" />
    //         {props.errors.endDate && (
    //           <div id="feedback">{props.errors.endDate}</div>
    //         )}

    //         <TextFieldComponent propsData={props} name="binusianName" />
    //         {props.errors.binusianName && (
    //           <div id="feedback">{props.errors.binusianName}</div>
    //         )}

    //         <button type="submit">Submit</button>
    //       </form>
    //     )}
    //   </Formik>
    // </div>

    // <Container>
    //   <DatePickerComponent onChildDataChange={handleDataFromChild}/>
    //   <TextFieldMultiComponent onChildDataChange={handleDataTextArea}/>
    //   <TextFieldMultiComponent onChildDataChange={handleDataTextArea2}/>
    //   <DropdownlistComponent/>
    //   {/* <TextAreaComponent onChildDataChange={handleDataTextArea}/> */}
    //   {/* <TextAreaComponent onChildDataChange={handleDataTextArea2}/> */}
    // </Container>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

export default Questionnaire;
